import React from 'react'
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../../ui/dialog"

const QRpopUp = ({ QRcode, Close, Open }) => {
    return (
        <Dialog open={Open} onOpenChange={Close}>
            <DialogContent className="max-w-md">
                <DialogHeader>
                    <DialogTitle className="text-center text-xl">Scan QR Code</DialogTitle>
                </DialogHeader>
                <div className="flex flex-col items-center justify-center pt-6 ">
                    <div className="w-full max-w-sm p-4 bg-card rounded-lg border-2">
                        <img
                            className="w-full h-auto"
                            src={QRcode}
                            alt="QR Code"
                        />
                    </div>
                    <p className="mt-4 text-lg font-semibold text-gray-700 dark:text-gray-300">
                        SCAN ME
                    </p>
                </div>
            </DialogContent>
        </Dialog>
    )
}
export default QRpopUp;